<template>
    <v-container grid-list-lg fluid px-0 py-0 my-0 mx-0 fill-height>
        <v-layout row wrap modal__block>
            <span class="modal__close" @click="closeModal"></span>
            <v-flex xs12 modal__wrapper :class="{ 'isBlocked': !editMode }">
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-layout form__row row wrap v-if="editMode">
                        <v-flex xs12 text-left>
                            <h1>{{$t('components.tasks.add.title')}}</h1>
                        </v-flex>
                        <v-flex xs12 py-0>
                            <v-divider />
                        </v-flex>
                    </v-layout>

                    <v-layout form__row row wrap>
                        <!-- <v-flex xs1>
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-width="200"
                                v-if="task && task.backgroundColor && task.backgroundColor.hex"
                                offset-x
                            >
                                <template v-slot:activator="{ on }">
                                    <span
                                        v-on="on"
                                        class="task__background-icon"
                                        :style="{ backgroundColor: task.backgroundColor.hex ? task.backgroundColor.hex : '' }"
                                    ></span>
                                </template>

                                <v-color-picker
                                    v-model="task.backgroundColor"
                                    mode="hexa"
                                    hide-mode-switch
                                ></v-color-picker>
                            </v-menu>
                        </v-flex>-->
                        <v-flex xs4>
                            <v-autocomplete
                                v-model="task.type"
                                :items="tasksTypes"
                                :label="$t('components.tasks.add.taskType')"
                                item-text="name"
                                item-value="value"
                                :rules="rules.type"
                                :error-messages="errorMessages.type"
                                :disabled="!editMode"
                                required
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs8>
                            <v-text-field
                                v-model="task.name"
                                :label="$t('components.tasks.add.taskName')"
                                :rules="rules.rule"
                                :disabled="!editMode"
                                required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout form__row row wrap>
                        <v-flex xs12>
                            <v-autocomplete
                                v-model="task.taskUsers"
                                :disabled="isUpdating"
                                :items="people"
                                chips
                                color="primary"
                                :label="$t('components.tasks.add.responsible')"
                                item-text="full_name"
                                item-value="id"
                                multiple
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                        v-bind="data.attrs"
                                        :input-value="data.selected"
                                        close
                                        @click="data.select"
                                        @click:close="remove(data.item)"
                                    >
                                        <v-avatar left>
                                            <v-img
                                                :src="data.item.avatar ? data.item.avatar : 'https://cdn.vuetifyjs.com/images/lists/1.jpg'"
                                            ></v-img>
                                        </v-avatar>
                                        {{ data.item.full_name }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                        <v-list-item-avatar>
                                            <img
                                                :src="data.item.avatar ? data.item.avatar : 'https://cdn.vuetifyjs.com/images/lists/1.jpg'"
                                            />
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="data.item.full_name"></v-list-item-title>
                                            <v-list-item-subtitle>{{data.item.role | formatRole}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                    </v-layout>

                    <v-layout form__row row wrap>
                        <v-flex xs4>
                            <v-menu
                                ref="date_start"
                                v-model="dateStart"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="date_start"
                                        :label="$t('components.tasks.add.dateStart')"
                                        prepend-icon="event"
                                        v-on="on"
                                        v-on:blur="formatDateStart"
                                        :rules="rules.rule"
                                        v-mask="'##.##.####'"
                                        :disabled="!editMode"
                                        return-masked-value
                                        required
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    ref="picker"
                                    v-model="task.date_start"
                                    :max="task.date_end"
                                    min="2020-01-01"
                                    @change="saveDateStart"
                                    llocale="ru-ru"
                                    first-day-of-week="1"
                                    no-title
                                ></v-date-picker>
                            </v-menu>
                        </v-flex>

                        <v-flex xs2>
                            <v-menu
                                ref="date_start_time"
                                v-model="dateStartTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="dateStartTime"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="date_start_time"
                                        :label="$t('components.tasks.add.time')"
                                        v-mask="'##:##'"
                                        prepend-icon="access_time"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="dateStartTime"
                                    v-model="date_start_time"
                                    format="24hr"
                                    full-width
                                    @click:minute="$refs.date_start_time.save(date_start_time)"
                                ></v-time-picker>
                            </v-menu>
                        </v-flex>

                        <v-flex xs4>
                            <v-menu
                                ref="date_end"
                                v-model="dateEnd"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="date_end"
                                        :label="$t('components.tasks.add.dateEnd')"
                                        prepend-icon="event"
                                        v-on="on"
                                        v-on:blur="formatDateEnd"
                                        :rules="rules.rule"
                                        v-mask="'##.##.####'"
                                        :disabled="!editMode"
                                        return-masked-value
                                        required
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    ref="picker"
                                    v-model="task.date_end"
                                    :min="task.date_start"
                                    max="2022-01-01"
                                    @change="saveDateEnd"
                                    llocale="ru-ru"
                                    first-day-of-week="1"
                                    no-title
                                ></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs2>
                            <v-menu
                                ref="date_end_time"
                                v-model="dateEndTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="dateEndTime"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="date_end_time"
                                        :label="$t('components.tasks.add.time')"
                                        v-mask="'##:##'"
                                        prepend-icon="access_time"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="dateEndTime"
                                    v-model="date_end_time"
                                    format="24hr"
                                    full-width
                                    @click:minute="$refs.date_end_time.save(date_end_time)"
                                ></v-time-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs6>
                            <v-select
                                v-model="task.event_created"
                                :items="filteredReminders"
                                :label="$t('components.tasks.add.authorEvent')"
                                multiple
                                chips
                                :hint="$t('components.tasks.add.moreSelectedHint')"
                                item-text="name"
                                item-value="value"
                                persistent-hint
                            ></v-select>
                        </v-flex>
                        <v-flex xs6>
                            <v-select
                                v-model="task.event_created_author"
                                :items="filteredReminders"
                                :label="$t('components.tasks.add.reminderEvent')"
                                multiple
                                chips
                                :hint="$t('components.tasks.add.moreSelectedHint')"
                                item-text="name"
                                item-value="value"
                                persistent-hint
                            ></v-select>
                        </v-flex>
                    </v-layout>

                    <v-layout form__row row wrap>
                        <v-flex xs12>
                            <v-textarea
                                v-model="task.description"
                                :label="$t('components.tasks.add.description')"
                                :rules="rules.rule"
                                :disabled="!editMode"
                                required
                            ></v-textarea>
                        </v-flex>
                    </v-layout>

                    <v-layout form__row form__errors row wrap v-if="errors">
                        <v-flex xs12>
                            {{$t('components.tasks.add.checkErrors')}}:
                            <strong
                                v-for="(error, idx) in errors"
                                :key="`error_f${idx}`"
                            >{{ error }}</strong>
                        </v-flex>
                    </v-layout>

                    <v-layout form__row row wrap v-if="editMode">
                        <v-flex xs12>
                            <v-btn color="primary" @click="validate" class>{{$t('components.tasks.add.submit')}}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import rules from "@/utils/data/rules";
import showNotify from "@/services/noty";
import { mask } from "vue-the-mask";
import TaskModel from "@/models/TaskModel";
import formatRole from "@/mixins/filters/formatRole";
import i18n from "@/services/i18n";

export default {
    name: "AddTask",
    directives: { mask },
    mixins: [formatRole],
    data: () => ({
        isLoaded: false,
        task: {},
        valid: false,
        dateStart: false,
        date_start: "", // new Date().toISOString().substr(0, 10),
        dateEnd: false,
        date_end: "",
        date_start_time: "12:00",
        dateStartTime: false,
        date_end_time: "13:00",
        dateEndTime: false,
        errors: null,
        errorMessages: {
            snils: "",
            inn: "",
            type: ""
        },
        newErrorMessages: {
            snils: "",
            inn: "",
            type: ""
        },
        tasksTypes: [
            { name: i18n.t('tasksTypes.10'), value: 10 },
            { name: i18n.t('tasksTypes.20'), value: 20 }
        ],
        tasksReminders: [
            { name: i18n.t('tasksReminders.5'), value: 5 },
            { name: i18n.t('tasksReminders.10'), value: 10 },
            { name: i18n.t('tasksReminders.30'), value: 30 },
            { name: i18n.t('tasksReminders.60'), value: 60 },
            { name: i18n.t('tasksReminders.120'), value: 120 },
            { name: i18n.t('tasksReminders.180'), value: 180 }
        ],
        rules,
        isUpdating: false,
        people: []
    }),
    props: {
        editedTask: {
            type: Object
        },
        isCreate: {
            type: Boolean
        },
        editMode: {
            type: Boolean
        }
    },
    methods: {
        notify(key, data) {
            return showNotify(key, data);
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.createTask();
            }
        },
        async getPeople() {
            const url = "v1/task/get-responsible";

            await apiCallTrue({ url })
                .then(response => {
                    this.people =
                        response && response.data && response.data.data
                            ? response.data.data
                            : [];
                })
                .catch(error => console.log("ERROR", error));
        },

        async createTask() {
            this.errors = null;
            const method = "POST";
            const data = Object.assign({}, this.task);
            data.date_start = `${this.task.date_start} ${this.date_start_time}`;
            data.date_end = `${this.task.date_end} ${this.date_end_time}`;
            const url = "v1/task";
            // const url = this.isCreate ? "v1/task" : `v1/task/${this.task.id}`;

            await apiCallTrue({
                url,
                data,
                method
            })
                .then(() => {
                    this.notify("task-created", this.task);
                    setTimeout(() => this.closeModalAndUpdate(), 400);
                })
                .catch(error => {
                    this.errors = [];
                    this.errors[0] = error.message;
                    this.errorMessages = this.errors;
                });
        },

        addTask() {
            this.errors = null;
            this.errorMessages = Object.assign({}, this.newErrorMessages);
            this.$emit("addTask", this.task);
        },
        updateTasks(task) {
            this.errors = null;
            this.errorMessages = Object.assign({}, this.newErrorMessages);
            this.$emit("updateTasks", task);
        },
        saveDateStart(date) {
            this.$refs.date_start.save(date);
            this.deFormatDateStart();
        },
        formatDateStart() {
            if (this.date_start) {
                this.task.date_start = this.date_start
                    .split(".")
                    .reverse()
                    .join("-");
            }
        },
        deFormatDateStart() {
            if (this.task.date_start) {
                this.date_start = this.task.date_start
                    .split("-")
                    .reverse()
                    .join(".");
            }
        },
        saveDateEnd(date) {
            this.$refs.date_end.save(date);
            this.deFormatDateEnd();
        },
        formatDateEnd() {
            if (this.date_end) {
                this.task.date_end = this.date_end
                    .split(".")
                    .reverse()
                    .join("-");
            }
        },
        deFormatDateEnd() {
            if (this.task.date_end) {
                this.date_end = this.task.date_end
                    .split("-")
                    .reverse()
                    .join(".");
            }
        },
        closeModal() {
            this.$emit("closeModal");
        },
        closeModalAndUpdate() {
            this.$emit("closeModalAndUpdate");
        },
        remove(item) {
            const index = this.task.taskUsers.indexOf(item.id);
            if (index >= 0) this.task.taskUsers.splice(index, 1);
        }
    },
    computed: {
        ...mapState({
            role: state => state.user.profile.role
        }),
        filteredReminders() {
            const output = this.tasksReminders.filter(item => {
                return (
                    item.value !== this.task.reminder1 ||
                    item.value !== this.task.reminder2
                );
            });
            return output;
        }
    },
    watch: {
        isCreate(val) {
            if (!val) {
                this.task = Object.assign({}, this.editedTask);
                this.deFormatAssignedAt();
            } else {
                this.task = new TaskModel();
                this.date_start = "";
                this.date_end = "";
                this.errors = null;
                this.errorMessages = Object.assign({}, this.newErrorMessages);
                this.$refs.form.resetValidation();
            }
        },
        dateStart(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
        dateEnd(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
        isUpdating(val) {
            if (val) {
                setTimeout(() => (this.isUpdating = false), 3000);
            }
        }
    },
    mounted() {
        this.getPeople();
        // this.task = new TaskModel();
        // if (
        //     !this.editedTask
        // ) {
        //     this.task = new TaskModel();
        // } else {
        //     this.task = Object.assign({}, this.editedTask);
        // }
        this.task = Object.assign({}, this.editedTask);
        this.deFormatDateStart();
        this.deFormatDateEnd();
        this.$refs.form.resetValidation();
    }
};
</script>
<style lang="scss">
// .task {
//     &__background-icon {
//         cursor: pointer;
//         display: block;
//         height: 100%;
//         width: 100%;
//         max-height: 50px;
//         max-width: 50px;
//         background-color: #eee;
//         // position: relative;
//         // &::after {
//         //     content: "";
//         //     display: block;
//         //     margin: 0 auto 0;
//         //     height: 15px;
//         //     width: 15px;
//         //     transform: rotate(45deg);
//         //     border: 2px solid #fff;
//         //     border-width: 2px 2px 0 0;
//         //     box-shadow: 1px -1px 1px #aaa;
//         //     position: relative;
//         //     top: 20px;
//         // }
//     }
// }
</style>
